/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchResponseResponse,
  NoContentResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get Pouch last status(version V0000000000) record for a pouchID
 * @summary Get Pouch of latest status for a pouchID
 */
export const getPouch = (pouchID: string, signal?: AbortSignal) => {
  return customInstance<GetPouchResponseResponse | NoContentResponse>({
    url: `/bm-pouch-management/v1/pouch/${pouchID}`,
    method: 'get',
    signal,
  });
};

export const getGetPouchQueryKey = (pouchID: string) => {
  return [`/bm-pouch-management/v1/pouch/${pouchID}`] as const;
};

export const getGetPouchQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouch>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouch>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchQueryKey(pouchID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouch>>> = ({ signal }) =>
    getPouch(pouchID, signal);

  return { queryKey, queryFn, enabled: !!pouchID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchQueryResult = NonNullable<Awaited<ReturnType<typeof getPouch>>>;
export type GetPouchQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get Pouch of latest status for a pouchID
 */
export const useGetPouch = <
  TData = Awaited<ReturnType<typeof getPouch>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouch>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchQueryOptions(pouchID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
